import { createRoot } from 'react-dom/client';
import { CleanApiApp } from './cleanapi';
import { provideI18n } from '@/i18n.ts';
import {
  AUTHENTICATION_FAKE_API,
  AUTHENTICATION_OPENID,
  type AuthenticationAdapter,
  login,
  provideAuthentication,
} from '@/generic/authentication';
import { ofetch } from 'ofetch';

import '@ippon-ui/styles/fonts/open-sans/400.css';
import '@ippon-ui/styles/fonts/open-sans/600.css';
import '@ippon-ui/styles/fonts/open-sans/700.css';
import '@ippon-ui/styles/fonts/saira-extra-condensed/700.css';
import '@ippon-ui/styles/icons/ionicons.css';
import '@ippon-ui/styles/tikui.css';
import '@ippon-ui/styles/prism-ippon.css';

import { type AuthenticationConfig, configSchema, provideConfig } from '@/config';

const config = await ofetch('/config.json', {
  method: 'GET',
}).then((data) => configSchema.parse(data));

provideConfig(config);

const toAuthenticationAdapter = (
  authenticationConfig: AuthenticationConfig,
): AuthenticationAdapter => {
  if (authenticationConfig === 'fake') {
    return {
      kind: AUTHENTICATION_FAKE_API,
    };
  }

  return {
    kind: AUTHENTICATION_OPENID,
    authority: authenticationConfig.authority,
    clientId: authenticationConfig.clientId,
  };
};

provideAuthentication({
  adapter: toAuthenticationAdapter(config.authentication),
});
await login();
await provideI18n();

createRoot(document.getElementById('root')!).render(<CleanApiApp />);
